<!-- <div class="card bg-white dark:bg-gray-800 rounded-xl shadow-md h-full p-2">
  <div class="card-body h-full p-2">
    <div #pdfViewerLAccount id="pdfViewerLAccount" class="w-full h-full"></div>
  </div>
</div> -->

<div class="wrapper" [class.single-file]="fileList.length === 1">
  <div class="sidebar" *ngIf="fileList.length > 1">
    <div class="header">Driver License</div>
    <form class="checkbox-form">
      <div class="bold" style="padding: 10px">
        Click on files below to view.
      </div>
      <div
        *ngFor="let file of fileList"
        class="flex items-center mb-2 px-3 py-2 rounded-md border cursor-pointer select-none transition-colors duration-150 active:shadow-inner"
        [ngClass]="file.url === selectedUrl ? selectedFileClass : fileClass"
        [title]="file.name"
        (click)="onClickFile(file.url)"
      >
        <!--*ngIf="file.type === 'pdf'"-->
          <i class="fa fa-file-pdf" [ngClass]="file.url === selectedUrl ? 'text-white' : 'text-red-500'"></i>
          <span class="ml-2 truncate">&nbsp;{{ file.name }}</span>
      </div>
    </form>
  </div>
  <div class="content" [class.full-width]="fileList.length === 1">
    <div *ngIf="pdfLoadError" class="p-4 mb-4 text-red-600 bg-red-50 border border-red-200 rounded">
      <strong>Error:</strong> {{ pdfLoadError }}
    </div>
    <gd-pdfviewer *ngIf="!pdfLoadError" [rawPdfData]="selectedFormData"></gd-pdfviewer>
  </div>
</div>
